<template>
  <div id="app">
    <HeaderMain />
    <MainHome />
  </div>
</template>

<script>
import MainHome from "./views/MainHome.vue";
import HeaderMain from "./components/HeaderMain";

export default {
  name: "App",
  components: {
    HeaderMain,
    MainHome,
  },
};
</script>

<style>
* {
  margin: 0;
  padding: 0;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
}
</style>
